<app-action-more [fontAwesomeIconClass]="'fa-solid fa-i-cursor'" [actionLabel]="'Rename Folder'" (click)="onSelected()"></app-action-more>
